import {combineReducers} from '@reduxjs/toolkit';
import {accountAuditReducer} from 'src/modules/profile/account/tabs/audit-log/audit-log.reducer';

import {accountProfileSlice} from '../tabs/account-profile/services/account-profile-slice';
import {accountEntitlementsAssignedReducer} from '../tabs/entitlements/assigned/account-entitlement-assigned.reducer';
import {accountDatasetEntitlementsAssignedReducer} from '../tabs/entitlements/dataset/account-dataset-entitlements.reducer';
import {mcpEntitlementsAssignedReducer} from '../tabs/entitlements/mcp/mcp-entitlement-assigned.reducer';
import {licenseAndFeatures} from '../tabs/license-and-features/license-features-reducer';
import {mcpSlice} from '../tabs/mcp/services/mcp-slice';
import {usersAndGroups} from '../tabs/users-and-groups/users-and-groups-reducer';


export const accountPageTabsReducer = combineReducers({
    accountProfile: accountProfileSlice.reducer,
    usersAndGroups,
    licenseAndFeatures,
    entitlements: accountEntitlementsAssignedReducer,
    datasetEntitlements: accountDatasetEntitlementsAssignedReducer,
    mcpEntitlements: mcpEntitlementsAssignedReducer,
    accountAuditLog: accountAuditReducer,
    mcp: mcpSlice.reducer,
});
